
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import Modal from '@/components/Modal.vue';
	import SearchSVG from '@/components/SearchSVG.vue';
	import { Observer } from 'mobx-vue';
	import { Patient } from '@/store/engine/openapi/generated';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import { SearchResult } from '@/components/modals/GlobalSearch.vue';

	@Observer
	@Component({
		components: { DualButtonModal, Modal, SearchSVG }
	})
	export default class PatientRow extends Vue {
		@Prop({ required: true }) searchResult?: SearchResult;

		private onPatientClick() {
			this.$emit('patientClick', this.searchResult);
		}

		private timestampToDate(val) {
			if (+val <= -2209118287000) {
				return '-';
			}
			const date = new Date(+val);
			const year = date.getUTCFullYear();
			const month = date.getUTCMonth();
			const day = date.getUTCDate();
			return month + 1 + '/' + day + '/' + year;
		}

		private lastUpdateParse(val: string) {
			try {
				let date = val.split('T')[0];
				let months = date.split('-')[1];
				let years = date.split('-')[0];
				let day = date.split('-')[2];

				let time = val.split('T')[1];
				time = time.slice(0, -1);

				let toLocalTime = new Date(months + '/' + day + '/' + years + ' ' + time.split('.')[0] + ' UTC');

				// return toLocalTime.getMonth() + 1 + '/' + toLocalTime.getDate() + '/' + toLocalTime.getFullYear() + ' ' + toLocalTime.toLocaleTimeString('en-US');
				return toLocalTime.toLocaleDateString('en-US') + ' ' + toLocalTime.toLocaleTimeString('en-US');
			} catch (e) {
				return 'unknown';
			}
		}
	}
